import { Component, input } from '@angular/core';
import { SummaryGraphsComponent } from '../summary-graphs/summary-graphs.component';
import { SummaryResumeComponent } from '../summary-resume/summary-resume.component';
import { Project } from 'src/app/entities/project/project';
import { TimeTrack } from 'src/app/entities/time-track/time-track';
import { User } from 'src/app/entities/user/user';
import { DateService } from 'src/app/services/date-service/date.service';
import { FiltersService } from 'src/app/services/filters-service/filters.service';
import { CustomDateFilterComponent, DateFiltersValues } from '../../atoms/custom-date-filter/custom-date-filter.component';

@Component({
  selector: 'app-reports-summary',
  imports: [SummaryGraphsComponent, SummaryResumeComponent, CustomDateFilterComponent],
  templateUrl: './reports-summary.component.html',
  styleUrl: './reports-summary.component.scss'
})
export class ReportsSummaryComponent {

  projects = input<Project[]>([]);
  timeTracks = input<TimeTrack[]>([]);
  users = input<User[]>([]);

  periodStart = new Date();

  periodEnd = new Date();

  constructor(
    protected dateService: DateService,
    protected filters: FiltersService
  ) { }

  protected setDateFilterPeriods(event: DateFiltersValues) {
    this.periodStart = new Date(event.startDate);
    this.periodEnd = new Date(event.endDate);

    this.setTracksFilterDates(
      this.dateService.getLocalIsosString(this.periodStart),
      this.dateService.getLocalIsosString(this.periodEnd)
    );
  }

  protected setTracksFilterDates(start: string, end: string): void {
    this.filters.setTimeTracksFilters({
      from: start,
      to: end
    });
  }
}
